angular.module("app.const", [])
.constant("Error", "Error String");
